module.exports = __webpack_public_path__ + "static/media/tableau.52a27b4b.svg";